// extracted by mini-css-extract-plugin
export var section = "_2s-1";
export var topNav = "_2s-0";